import { PlaybookTitle } from "./PlaybookTitle";
import { Divider, Stack, Typography } from "@mui/material";
import { H4Component } from "./H4Component";
import { TextBlock } from "./TextBlock";
import { CardWrapper } from "./CardWrapper";
import { OutboundSequenceType } from "../../../../types";

const Title = ({ title }: { title: string }) => (
  <Typography
    component="h5"
    sx={{
      color: "#024760",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "22px",
    }}
  >
    {title}
  </Typography>
);

const SignBlock = () => {
  return (
    <Stack>
      {["Best,", "[Your Name]"].map((el) => (
        <Typography
          key={el}
          sx={{
            color: "#1F2932",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
          }}
        >
          {el}
        </Typography>
      ))}
    </Stack>
  );
};

export const OutboundSequenceBlock = ({
  touch_1_connection,
  touch_2_intro_email,
  touch_3_dm_followup,
  touch_4_use_case_email,
  touch_5_final_nudge,
  topic,
}: OutboundSequenceType & { topic: string }) => {
  return (
    <Stack gap={"20px"} id={topic}>
      <PlaybookTitle text={topic} />
      {touch_1_connection && (
        <Stack gap={"8px"}>
          {touch_1_connection.goal && (
            <>
              <H4Component text={"Call Goal"} />
              <TextBlock text={[touch_1_connection.goal]} />
            </>
          )}
        </Stack>
      )}
      <CardWrapper isCard={true}>
        <Stack gap={"20px"}>
          <Title title={"Day 3–4: Initial Awareness & Credibility"} />
          <Stack gap={"12px"}>
            <H4Component
              text={"Touch 1: LinkedIn Connect (Day 3)"}
              color={"#005EAB"}
            />
            <H4Component text={"Message:"} color={"#024760"} />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={[touch_1_connection.message]} />
            </Stack>
          </Stack>
          <Divider sx={{ margin: "8px 0", width: "100%" }} />
          <Stack gap={"12px"}>
            <H4Component
              text={"Touch 2: Intro Email (Day 4)"}
              color={"#005EAB"}
            />
            <Stack flexDirection={"row"} gap={"4px"}>
              <H4Component text={"Subject:"} color={"#024760"} />
              <H4Component
                text={touch_2_intro_email.subject}
                color={"#024760"}
                fontWeight={400}
              />
            </Stack>
            <Stack
              paddingLeft="16px"
              borderLeft={"4px solid #E5E5E5"}
              gap={"12px"}
            >
              <TextBlock text={touch_2_intro_email.body} />
              <SignBlock />
            </Stack>
          </Stack>
        </Stack>
      </CardWrapper>

      <CardWrapper isCard={true}>
        <Stack gap={"20px"}>
          <Title title={"Day 5–7: Value-Led Engagement"} />
          <Stack gap={"12px"}>
            <H4Component
              text={"Touch 3: LinkedIn DM (Day 5)"}
              color={"#005EAB"}
            />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={[touch_3_dm_followup.message]} />
            </Stack>
          </Stack>
          <Divider sx={{ margin: "8px 0", width: "100%" }} />
          <Stack gap={"12px"}>
            <H4Component
              text={"Touch 4: Email – Use Case + Pain Point (Day 7)"}
              color={"#005EAB"}
            />
            <Stack flexDirection={"row"} gap={"4px"}>
              <H4Component text={"Subject:"} color={"#024760"} />
              <H4Component
                text={touch_4_use_case_email.subject}
                color={"#024760"}
                fontWeight={400}
              />
            </Stack>
            <Stack
              paddingLeft="16px"
              borderLeft={"4px solid #E5E5E5"}
              gap={"12px"}
            >
              <TextBlock text={touch_4_use_case_email.body} />
              <SignBlock />
            </Stack>
          </Stack>
        </Stack>
      </CardWrapper>

      <CardWrapper isCard={true}>
        <Stack gap={"20px"}>
          <Title title={"Day 8–10: Final CTA + Voicemail"} />
          <Stack gap={"12px"}>
            <H4Component
              text={"Touch 5: Voicemail Drop + Email (Day 8–10)"}
              color={"#005EAB"}
            />
            <H4Component text={"Voicemail Script:"} color={"#024760"} />
            <Stack paddingLeft="16px" borderLeft={"4px solid #E5E5E5"}>
              <TextBlock text={[touch_5_final_nudge.voicemail]} />
            </Stack>
          </Stack>
          <Divider sx={{ margin: "8px 0", width: "100%" }} />
          <Stack gap={"12px"}>
            <Stack flexDirection={"row"} gap={"4px"}>
              <H4Component text={"Email Subject:"} color={"#024760"} />
              <H4Component
                text={touch_5_final_nudge.subject}
                color={"#024760"}
                fontWeight={400}
              />
            </Stack>
            <Stack
              paddingLeft="16px"
              borderLeft={"4px solid #E5E5E5"}
              gap={"12px"}
            >
              <TextBlock text={touch_5_final_nudge.body} />
              <SignBlock />
            </Stack>
          </Stack>
        </Stack>
      </CardWrapper>
    </Stack>
  );
};
